import React from "react";
import PropTypes from "prop-types";
import ApplicationUDFormView from "./ApplicationUDFormView";
import ApplicationUDDetailsList from "./ApplicationUDDetailsList";

import { DataActions } from "../../services/AxoServices";

import { withRouter, LoadingIndicator } from "../../utilities/LexUtilities";

class ApplicationUDDetailsView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editing: false,
    };
  }

  static propTypes = {
    applicationUDs: PropTypes.array.isRequired,
  };

  onSubmit = async (model) => {
    let response = await DataActions.updateApplicationUD(model);

    if (!response.ok) {
      return false;
    }

    this.setState({ editing: false });
  };

  onCancel = () => {
    this.setState({ editing: false });
  };

  render() {
    let { match, applicationUDs } = this.props;

    let { editing } = this.state;

    let id = parseInt(match.params.id, 10);
    let model = applicationUDs.find((a) => a.id === id);

    if (!model) {
      return <LoadingIndicator />;
    }

    if (!editing) {
      return (
        <ApplicationUDDetailsList
          model={model}
          onEdit={() => this.setState({ editing: true })}
        />
      );
    }

    return (
      <ApplicationUDFormView
        key={model.id}
        startValue={model}
        onSubmit={this.onSubmit}
        onCancel={this.onCancel}
      />
    );
  }
}

export default withRouter(ApplicationUDDetailsView);
